export default "__VITE_ASSET__BpSelSJL__"